const breakpoints = {
  mobile: getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-mobile'
  ),
  tablet: getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-tablet'
  ),
  desktop: getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-desktop'
  ),
  bigscreen: getComputedStyle(document.documentElement).getPropertyValue(
    '--breakpoint-bigscreen'
  ),
};
let currentBreakpoint = '';
let isMobile;

const updateCurrentBreakpoint = () => {
  if (window.matchMedia(`(min-width: ${breakpoints.bigscreen})`).matches) {
    currentBreakpoint = 'bigscreen';
    return;
  }
  if (window.matchMedia(`(min-width: ${breakpoints.desktop})`).matches) {
    currentBreakpoint = 'desktop';
    return;
  }
  if (window.matchMedia(`(min-width: ${breakpoints.tablet})`).matches) {
    currentBreakpoint = 'tablet';
    return;
  }
  currentBreakpoint = 'smartphone';
};

const updateIsMobile = () => {
  isMobile =
    currentBreakpoint !== 'desktop' && currentBreakpoint !== 'bigscreen';
};

const updateBreakpointInfo = () => {
  updateCurrentBreakpoint();
  updateIsMobile();
};

window.addEventListener('resize', updateBreakpointInfo);

updateBreakpointInfo();

export { breakpoints, currentBreakpoint, isMobile };
